export default __webpack_public_path__ + "88348978b91c67085505f69818dda693.png";